import { render, staticRenderFns } from "./SortComponent.vue?vue&type=template&id=0e1dc534&scoped=true"
import script from "./SortComponent.vue?vue&type=script&lang=ts"
export * from "./SortComponent.vue?vue&type=script&lang=ts"
import style0 from "./SortComponent.vue?vue&type=style&index=0&id=0e1dc534&prod&lang=scss&scoped=true"
import style1 from "./SortComponent.vue?vue&type=style&index=1&id=0e1dc534&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1dc534",
  null
  
)

export default component.exports